import { AxiosRequestConfig } from "axios";
import { stores } from "../../../../stores/stores";

export function addParametersToRequestHeaders(config: AxiosRequestConfig) {
    config.headers.Partner = stores.uiFlagsStore.partnerName;

    if (stores.userStore.username) {
        config.headers.username = stores.userStore.username;
    }
    if (stores.userStore.sessionId) {
        config.headers.session_id = stores.userStore.sessionId;
    }
    return config;
}
